module.exports = __webpack_public_path__ + "img/update-reinvite.fb148be9.svg";